<div class="flex flex-col lg:flex-row items-center justify-center gap-4 sm:gap-6 lg:gap-8 px-3 sm:px-4 mt-12">

<!-- Linkes App-Bild -->
    <div class="hidden lg:grid flex-1 lg:grid-cols-2 xl:grid-cols-3 gap-2 lg:gap-4 justify-items-center">
    <img 
        src="assets/img/AppVorschau1.png" 
        alt="Screenshot der KnOot App"
        class="w-full max-w-[180px] lg:max-w-[220px] lg:max-w-[220px] rounded-xl shadow-box"
    >

    <img 
        src="assets/img/AppVorschau2.png" 
        alt="Screenshot der KnOot App"
        class="w-full max-w-[180px] lg:max-w-[220px] lg:max-w-[220px] rounded-xl shadow-box"
    >

    <img 
        src="assets/img/AppVorschau3.png" 
        alt="Screenshot der KnOot App"
        class="w-full max-w-[180px] lg:max-w-[220px] lg:max-w-[220px] rounded-xl shadow-box"
    >

    <img 
        src="assets/img/AppVorschau4.png" 
        alt="Screenshot der KnOot App"
        class="w-full max-w-[180px] lg:max-w-[220px] lg:max-w-[220px] rounded-xl shadow-box"
    > 
    
     <img 
        src="assets/img/AppVorschau5.png" 
        alt="Screenshot der KnOot App"
        class="w-full max-w-[180px] lg:max-w-[220px] lg:max-w-[220px] rounded-xl shadow-box"
    >

     <img 
        src="assets/img/AppVorschau6.png" 
        alt="Screenshot der KnOot App"
        class="w-full max-w-[180px] lg:max-w-[220px] lg:max-w-[220px] rounded-xl shadow-box"
    >
</div>
<div class="flex flex-col items-center max-w-[480px] w-full">
    @if(verificationState){
    <div class="shadow-box flex flex-col items-center max-w-screen-sm mb-4">
        @if(verificationState == 'loading'){
        <h3>Deine E-Mail-Adresse wird bestätigt...</h3>
        } @else if(verificationState == 'success') {
        <h3 class="text-green">E-Mail-Adresse erfolgreich bestätigt!</h3>
        <p>Du kannst dich jetzt mit deinen Zugangsdaten anmelden.</p>
        }
        @else if(verificationState == 'error') {
        <h3 class="text-red">Fehler beim Bestätigen der E-Mail-Adresse!</h3>
        <p>Hoppla! Leider ist ein Fehler beim Bestätigen deiner E-Mail-Adresse aufgetreten. Bitte versuche es erneut.
            Sollte das Problem weiter bestehen, <a href="https://knoot-academy.de/kontakt/" target="_blank">melde dich
                bitte uns</a> oder der zuständigen Lehrkraft.</p>
        }
    </div>
    }
    <div class="shadow-box flex flex-col items-center max-w-[480px]">
        <!-- <img src="../../assets/img/login-penguin.webp" class="mt-12 mb-6 w-40 h-40 rounded-full"/> -->
        <img src="./assets/img/ci/academy1.png" alt="KnOot Logo" class="mt-6 mb-6 h-28 w-auto object-contain" />
        <h3>Login</h3>
        <div class="divide-y">
            <div class="mb-4">
                <p class="px-4 mt-2 mb-4 text-center">Mit einem Klick auf eine der Optionen wirst du zur Anmeldung
                    beim entsprechenden Anbieter weitergeleitet.</p>
                <app-social-login [returnUrl]="returnUrl" ></app-social-login>
            </div>

            <div class="my-4">
                <p class="px-4 mt-2 mb-4 text-center">Alternativer Login mit E-Mail & Passwort</p>

                <form (ngSubmit)="onSubmit()" [formGroup]="loginForm">
                    <div>
                        <label for="email" class="block text-sm font-medium leading-6">E-Mail-Adresse</label>
                        <div class="mt-2">
                            <input id="email" formControlName="email" name="email"
                                class="block w-full rounded border border-grey py-1.5" type="email" required [ngClass]="{
                                    'invalid': loginForm.get('email')?.invalid && (loginForm.get('email')?.touched)
                                  }">
                            @if (loginForm.get('email')?.invalid && (loginForm.get('email')?.touched)) {
                            <div class="text-red text-sm mt-2">
                                Ungültige E-Mail-Adresse
                            </div>
                            }
                        </div>
                    </div>

                    <div class="my-4">
                        <label for="password" class="block text-sm font-medium leading-6">Passwort</label>
                        <div class="mt-2">
                            <input id="password" formControlName="password" name="password"
                                class="block w-full rounded border border-grey py-1.5" type="password" required
                                placeholder="" [ngClass]="{
                                    'invalid': loginForm.get('password')?.invalid && (loginForm.get('password')?.touched)
                                  }">
                            @if (loginForm.get('password')?.invalid &&
                            (loginForm.get('password')?.touched)) {
                            <div class="text-red text-sm mt-2">
                                Passwort muss aus mindestens 8 Zeichen beinhalten
                            </div>
                            }
                        </div>
                    </div>

                    <div class="w-full flex flex-row justify-end items-center gap-4">
                        @if(manualLoginFailed){
                        @if(passwordResetTriggered){
                        <span class="text-green">Wenn du eine gültige E-Mail angegeben hast, haben wir dir soeben eine
                            Email geschickt, mit der du dein Passwort zurücksetzen kannst.</span>
                        } @else {
                        <span class="text-red">{{loginFailureMessage}}
                            @if(showPasswordReset){
                            <a (click)="resetPassword()" class="cursor-pointer"> Passwort vergessen?</a>
                            }
                        </span>
                        }
                        }
                        @if (loginForm.invalid) {
                        <button type="submit" disabled
                            class="white-button disabled cursor-not-allowed !h-12">Einloggen</button>
                        } @else {
                        <button type="submit" class="blue-button !h-12">Einloggen</button>
                        }
                    </div>
                </form>
            </div>

            <div class="my-4">
                <p class="px-4 mt-2 mb-4 text-center">Du hast noch keinen Account? <a routerLink="/register">
                    Jetzt registrieren!</a></p>
            </div>
        </div>
    </div>
</div>